module.exports = __webpack_public_path__ + "img/loader.6e22010c.gif";